export const CHECK_ZIP_SUCCESS = 'CHECK_ZIP_SUCCESS',
  CHECK_ZIP_FAIL = 'CHECK_ZIP_FAIL',
  GET_ALLOWED_SERVICES_SUCCESS = 'GET_ALLOWED_SERVICES_SUCCESS',
  GET_ALLOWED_SERVICES_FAIL = 'GET_ALLOWED_SERVICES_FAIL',
  SEARCH_TRACKING = 'SEARCH_TRACKING'
